// The NOOS guide (63_Noos.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Four tabs',
  tabsB: 'Dashboard is the replenishment view; Tier list holds each SAP code\'s NOOS tier; Supply has lead times and MOQ; Settings holds the default assumptions.',
  dayT: 'Pick the stock day',
  dayB: 'Choose which stock day to look at, refresh it, or take it out as Excel or a single HTML page. Editors can also make a share link.',
  filtersT: 'Entity and tier filters',
  filtersB: 'Limit the numbers to some entities or tiers. Reset assumptions puts the sliders below back to the saved defaults.',
  assumpT: 'Try other assumptions',
  assumpB: 'Move a slider to see what changes in the lists: target weeks, production lead time, service level and the excess threshold. It does not change the saved settings.',
  kpiT: 'What needs attention',
  kpiB: 'Four counts: below coverage, ROP alerts, excess and rows to review. Click one to open its list.',
  subsT: 'The lists',
  subsB: 'Overview, Below Coverage, ROP Alerts, Excess and Review Data. Sort or filter any column like in Excel.',
};
const ko = {
  tabsT: '네 개의 탭',
  tabsB: 'Dashboard는 보충 현황, Tier list는 SAP 코드별 NOOS 티어, Supply는 리드타임과 MOQ, Settings는 기본 가정값입니다.',
  dayT: '재고 기준일 선택',
  dayB: '볼 재고 기준일을 고르고, 새로고침하거나 Excel 또는 HTML 한 장으로 내려받습니다. 편집 권한자는 공유 링크도 만들 수 있습니다.',
  filtersT: '법인·티어 필터',
  filtersB: '특정 법인이나 티어만 골라 볼 수 있습니다. Reset assumptions를 누르면 아래 슬라이더가 저장된 기본값으로 돌아갑니다.',
  assumpT: '가정값 바꿔 보기',
  assumpB: '슬라이더(목표 주수, 생산 리드타임, 서비스 수준, 과잉 기준)를 움직이면 목록이 어떻게 바뀌는지 볼 수 있습니다. 저장된 설정은 바뀌지 않습니다.',
  kpiT: '확인이 필요한 항목',
  kpiB: 'Below coverage, ROP 알림, 과잉, 검토 대상 네 가지 건수입니다. 클릭하면 해당 목록이 열립니다.',
  subsT: '목록',
  subsB: 'Overview, Below Coverage, ROP Alerts, Excess, Review Data입니다. 열마다 Excel처럼 정렬·필터할 수 있습니다.',
};
const vi = {
  tabsT: 'Bốn tab',
  tabsB: 'Dashboard là màn bổ sung hàng; Tier list giữ tier NOOS của từng mã SAP; Supply có lead time và MOQ; Settings giữ các giả định mặc định.',
  dayT: 'Chọn ngày tồn kho',
  dayB: 'Chọn ngày tồn kho muốn xem, làm mới, hoặc xuất ra Excel hay một trang HTML. Người có quyền sửa còn tạo được link chia sẻ.',
  filtersT: 'Bộ lọc entity và tier',
  filtersB: 'Chỉ xem một số entity hoặc tier. Nút Reset assumptions đưa các thanh trượt bên dưới về giá trị đã lưu.',
  assumpT: 'Thử giả định khác',
  assumpB: 'Kéo thanh trượt để xem danh sách đổi thế nào: số tuần mục tiêu, lead time sản xuất, mức phục vụ và ngưỡng tồn dư. Việc này không đổi cài đặt đã lưu.',
  kpiT: 'Phần cần chú ý',
  kpiB: 'Bốn con số: dưới mức bao phủ, cảnh báo ROP, tồn dư và dòng cần xem lại. Bấm vào một ô để mở danh sách tương ứng.',
  subsT: 'Các danh sách',
  subsB: 'Overview, Below Coverage, ROP Alerts, Excess và Review Data. Sắp xếp hoặc lọc từng cột như trong Excel.',
};
const zh = {
  tabsT: '四个标签页',
  tabsB: 'Dashboard 是补货视图；Tier list 记录每个 SAP 代码的 NOOS 层级；Supply 有交期和 MOQ；Settings 是默认假设值。',
  dayT: '选择库存日期',
  dayB: '选择要查看的库存日期，可刷新，或导出为 Excel 或单页 HTML。有编辑权限的人还可以生成分享链接。',
  filtersT: '实体和层级筛选',
  filtersB: '只看部分实体或层级。点击 Reset assumptions 会把下方滑块恢复为已保存的默认值。',
  assumpT: '试试其他假设',
  assumpB: '拖动滑块（目标周数、生产交期、服务水平、过剩阈值），查看列表如何变化。这不会改动已保存的设置。',
  kpiT: '需要关注的项目',
  kpiB: '四个数字：低于覆盖、ROP 预警、过剩和待复核行。点击其中一个即可打开对应列表。',
  subsT: '各个列表',
  subsB: 'Overview、Below Coverage、ROP Alerts、Excess 和 Review Data。每一列都可以像 Excel 一样排序或筛选。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Quatre onglets",
  "tabsB": "Réapprovisionnement NOOS est la vue de réapprovisionnement ; Liste des tiers contient le niveau NOOS de chaque code SAP ; Paramètres d’approvisionnement a les délais et les MOQ ; Paramètres contient les hypothèses par défaut.",
  "dayT": "Choisir le jour de stock",
  "dayB": "Choisissez le jour de stock à consulter, actualisez-le, ou sortez-le en Excel ou en une page HTML. Les éditeurs peuvent aussi créer un lien de partage.",
  "filtersT": "Filtres d'entité et de niveau",
  "filtersB": "Limitez les chiffres à certaines entités ou à certains niveaux. Réinitialiser les hypothèses remet les curseurs ci-dessous aux valeurs par défaut enregistrées.",
  "assumpT": "Essayer d'autres hypothèses",
  "assumpB": "Déplacez un curseur pour voir ce qui change dans les listes : semaines cibles, délai de production, niveau de service et seuil d'excédent. Cela ne modifie pas les paramètres enregistrés.",
  "kpiT": "Ce qui demande de l'attention",
  "kpiB": "Quatre compteurs : sous la couverture, alertes ROP, excédent et lignes à vérifier. Cliquez sur l'un d'eux pour ouvrir sa liste.",
  "subsT": "Les listes",
  "subsB": "Vue d'ensemble, Sous la couverture, Alertes ROP, Excédent et Données à vérifier. Triez ou filtrez n'importe quelle colonne comme dans Excel."
};
const ja = {
  "tabsT": "4つのタブ",
  "tabsB": "「NOOS補充」は補充ビュー、「ティア一覧」は SAP コードごとの NOOS ティア、「供給パラメータ」はリードタイムと MOQ、「設定」は既定の前提条件です。",
  "dayT": "在庫日を選択",
  "dayB": "確認する在庫日を選び、更新したり、Excel または1ページの HTML として出力したりできます。編集権限のある方は共有リンクも作成できます。",
  "filtersT": "エンティティとティアのフィルター",
  "filtersB": "一部のエンティティやティアに数字を絞り込みます。「前提条件をリセット」で、下のスライダーが保存済みの既定値に戻ります。",
  "assumpT": "別の前提条件を試す",
  "assumpB": "スライダーを動かして、リストがどう変わるかを確認できます。対象週数、生産リードタイム、サービスレベル、過剰在庫のしきい値が対象です。保存済みの設定は変更されません。",
  "kpiT": "注意が必要なもの",
  "kpiB": "4つの件数：カバー不足、ROP アラート、過剰、確認が必要な行です。クリックするとそのリストが開きます。",
  "subsT": "リスト",
  "subsB": "「概要」「カバレッジ不足」「ROP アラート」「過剰在庫」「データ確認」です。Excel と同じように、どの列でも並べ替えや絞り込みができます。"
};

const dictionary = { ns: 'tourNoos', en, ko, vi, zh, fr, ja };
export default dictionary;
